var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"error-div"},[_vm._v("\n        "+_vm._s(_vm.msg)+"\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }